module.exports = __webpack_public_path__ + "img/2.9075c8dd.jpg";